import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Education.css';
import { FaGraduationCap, FaCalendarAlt, FaMapMarkerAlt, FaBook, FaAward, FaLaptopCode } from 'react-icons/fa';

const Education = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-out-cubic',
        });
    }, []);

    const education = {
        degree: "Bachelor of Information Technology",
        field: "Computer Science",
        university: "Kafr El-Sheikh University",
        location: "Kafr El-Sheikh, Egypt",
        startYear: 2023,
        endYear: 2027,
        status: "Third Year Student",
        gpa: "Very Good",
    };

    const achievements = [
        {
            icon: <FaLaptopCode />,
            title: "Web Development",
            description: "Building modern web applications with latest technologies",
        },
        {
            icon: <FaBook />,
            title: "Academic Excellence",
            description: "Maintaining strong academic performance",
        },
        {
            icon: <FaAward />,
            title: "Practical Projects",
            description: "Applying knowledge through real-world projects",
        },
    ];

    const currentYear = new Date().getFullYear();
    const progress = ((currentYear - education.startYear) / (education.endYear - education.startYear)) * 100;

    return (
        <section className="education" id="education">
            <div className="education-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
            </div>

            <div className="container education-container">
                <div className="section-header" data-aos="fade-up">
                    <h2 className="section-title">
                        <span className="gradient-text">Education</span>
                    </h2>
                    <p className="section-subtitle">
                        My academic journey and learning path
                    </p>
                </div>

                <div className="education-content">
                    {/* Main Education Card */}
                    <div className="education-card" data-aos="fade-up" data-aos-delay="100">
                        <div className="education-header">
                            <div className="degree-icon">
                                <FaGraduationCap />
                            </div>
                            <div className="degree-info">
                                <h3 className="degree-title">{education.degree}</h3>
                                <p className="degree-field">{education.field}</p>
                            </div>
                            <div className="status-badge">
                                <span className="status-dot"></span>
                                {education.status}
                            </div>
                        </div>

                        <div className="education-details">
                            <div className="detail-item">
                                <FaGraduationCap className="detail-icon" />
                                <div className="detail-content">
                                    <span className="detail-label">University</span>
                                    <span className="detail-value">{education.university}</span>
                                </div>
                            </div>

                            <div className="detail-item">
                                <FaMapMarkerAlt className="detail-icon" />
                                <div className="detail-content">
                                    <span className="detail-label">Location</span>
                                    <span className="detail-value">{education.location}</span>
                                </div>
                            </div>

                            <div className="detail-item">
                                <FaCalendarAlt className="detail-icon" />
                                <div className="detail-content">
                                    <span className="detail-label">Duration</span>
                                    <span className="detail-value">{education.startYear} - {education.endYear}</span>
                                </div>
                            </div>
                        </div>

                        {/* Progress Bar */}
                        <div className="progress-section">
                            <div className="progress-header">
                                <span className="progress-label">Academic Progress</span>
                                <span className="progress-percentage">{Math.round(progress)}%</span>
                            </div>
                            <div className="progress-bar">
                                <div className="progress-fill" style={{ width: `${progress}%` }}></div>
                            </div>
                            <div className="progress-years">
                                <span>{education.startYear}</span>
                                <span>{education.endYear}</span>
                            </div>
                        </div>
                    </div>

                    {/* Achievements Grid */}
                    <div className="achievements-section" data-aos="fade-up" data-aos-delay="200">
                        <h3 className="achievements-title">Key Focus Areas</h3>
                        <div className="achievements-grid">
                            {achievements.map((achievement, index) => (
                                <div
                                    className="achievement-card"
                                    key={index}
                                    data-aos="fade-up"
                                    data-aos-delay={300 + index * 100}
                                >
                                    <div className="achievement-icon">{achievement.icon}</div>
                                    <h4 className="achievement-title">{achievement.title}</h4>
                                    <p className="achievement-description">{achievement.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Education;
